import React from 'react';
import {
    IoAddCircle,
    IoAnalyticsOutline,
    IoDocumentTextOutline,
    IoHomeOutline,
    IoNotificationsOutline,
    IoPeopleOutline,
    IoPersonOutline,
    IoTicketOutline,
    IoTimerOutline,
} from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import './BottomTab.css';

const adminTabs = [
  { name: 'Home', icon: IoHomeOutline, path: '/admin/dashboard' },
  { name: 'Analytics', icon: IoAnalyticsOutline, path: '/admin/analytics' },
  { name: 'Users', icon: IoPeopleOutline, path: '/admin/users' },
  { name: 'Tickets', icon: IoTicketOutline, path: '/admin/tickets' },
  { name: 'Profile', icon: IoPersonOutline, path: '/admin/profile' },
];

const engineerTabs = [
  { name: 'Dashboard', icon: IoHomeOutline, path: '/engineer/dashboard' },
  { name: 'Tickets', icon: IoDocumentTextOutline, path: '/engineer/tickets' },
  { name: 'Profile', icon: IoPersonOutline, path: '/engineer/profile' },
];

const userTabs = [
  { name: 'Home', icon: IoHomeOutline, path: '/user/dashboard' },
  { name: 'History', icon: IoTimerOutline, path: '/user/history' },
  { name: 'Plus', icon: IoAddCircle, path: '/user/new-ticket', isCenter: true },
  { name: 'Notifications', icon: IoNotificationsOutline, path: '/user/notifications' },
  { name: 'Account', icon: IoPersonOutline, path: '/user/account' },
];

const areaHeadTabs = [
  { name: 'Dashboard', icon: IoHomeOutline, path: '/area-head/dashboard' },
  { name: 'Tickets', icon: IoTicketOutline, path: '/area-head/tickets' },
  { name: 'Visits', icon: IoTimerOutline, path: '/area-head/visits' },
  { name: 'Profile', icon: IoPersonOutline, path: '/area-head/profile' },
];

export const AdminBottomTab = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const adminLeftTabs = adminTabs.slice(0, 2);
  const adminRightTabs = adminTabs.slice(2, 5);

  const isActive = (path) =>
    location.pathname === path ||
    (path === '/admin/dashboard' && (location.pathname === '/admin' || location.pathname === '/admin/'));

  return (
    <div className="bottom-tab-wrapper admin-tab">
      <nav className="bottom-tab">
        {adminLeftTabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.name}
              className={`tab-item ${isActive(tab.path) ? 'active' : ''}`}
              onClick={() => navigate(tab.path)}
            >
              <Icon className="tab-icon" />
              <span className="tab-label">{tab.name}</span>
            </button>
          );
        })}
        <div className="tab-spacer" />
        {adminRightTabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.name}
              className={`tab-item ${isActive(tab.path) ? 'active' : ''}`}
              onClick={() => navigate(tab.path)}
            >
              <Icon className="tab-icon" />
              <span className="tab-label">{tab.name}</span>
            </button>
          );
        })}
      </nav>
      <button
        className="tab-fab"
        onClick={() => navigate('/admin/users', { state: { openAddModal: true } })}
        title="Add User"
      >
        <IoAddCircle className="fab-icon" />
      </button>
    </div>
  );
};

export const EngineerBottomTab = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="bottom-tab engineer-tab">
      {engineerTabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = location.pathname === tab.path ||
          (tab.path === '/engineer/dashboard' && (location.pathname === '/engineer' || location.pathname === '/engineer/'));
        return (
          <button
            key={tab.name}
            className={`tab-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <Icon className="tab-icon" />
            <span className="tab-label">{tab.name}</span>
          </button>
        );
      })}
    </nav>
  );
};

export const UserBottomTab = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="bottom-tab-wrapper user-tab">
      <nav className="bottom-tab">
        {userTabs.slice(0, 2).map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname === tab.path;
          return (
            <button
              key={tab.name}
              className={`tab-item ${isActive ? 'active' : ''}`}
              onClick={() => navigate(tab.path)}
            >
              <Icon className="tab-icon" />
              <span className="tab-label">{tab.name}</span>
            </button>
          );
        })}
        <div className="tab-spacer" />
        {userTabs.slice(3, 5).map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname === tab.path;
          return (
            <button
              key={tab.name}
              className={`tab-item ${isActive ? 'active' : ''}`}
              onClick={() => navigate(tab.path)}
            >
              <Icon className="tab-icon" />
              <span className="tab-label">{tab.name}</span>
            </button>
          );
        })}
      </nav>
      <button
        className="tab-fab"
        onClick={() => navigate('/user/new-ticket')}
        title="New Ticket"
      >
        <IoAddCircle className="fab-icon" />
      </button>
    </div>
  );
};

export const AreaHeadBottomTab = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path ||
    (path === '/area-head/dashboard' && (location.pathname === '/area-head' || location.pathname === '/area-head/'));

  return (
    <nav className="bottom-tab area-head-tab">
      {areaHeadTabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <button
            key={tab.name}
            className={`tab-item ${isActive(tab.path) ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <Icon className="tab-icon" />
            <span className="tab-label">{tab.name}</span>
          </button>
        );
      })}
    </nav>
  );
};
